import { ReactNode } from 'react';

import ComposeBookingStep from '../../../types/ComposeBookingStep';
import BookingParametersHeader from '../components/BookingParametersHeader/BookingParametersHeader';
import StepContainer from '../components/StepContainer/StepContainer';
import useComposeBookingProps from '../hooks/useComposeBookingProps';

type ComposeBookingLayoutProps = {
    children: ReactNode;
    currentStep: ComposeBookingStep;
};

const ComposeBookingLayout = ({
    children,
    currentStep,
}: ComposeBookingLayoutProps) => {
    const props = useComposeBookingProps();
    const hasParameters =
        props.parameters?.dockId || props.parameters?.boatModelId;

    return (
        <>
            <BookingParametersHeader
                parameters={props.parameters ?? {}}
                stepUrls={props.steps}
                currentStep={currentStep}
            />

            <StepContainer
                stepName={currentStep}
                borderRadius={hasParameters ? 'bottom' : 'all'}
            >
                {children}
            </StepContainer>
        </>
    );
};

export default ComposeBookingLayout;
